document.addEventListener("DOMContentLoaded", function () {
	ps_initTypingOnScroll(".ps-cta-text", 60, 0.6);
});
// cta animation
 function ps_initTypingOnScroll(selector, speed = 50, threshold = 0.6) {

    const elements = document.querySelectorAll(selector);

    elements.forEach((element) => {

      const originalText = element.textContent.trim();
      let typingTimeout;
      let isTyping = false;

      function startTyping() {
        if (isTyping) return;

        isTyping = true;
        element.textContent = "";
        element.classList.add("typing");

        let index = 0;

        function type() {
          if (index < originalText.length) {
            element.textContent += originalText.charAt(index);
            index++;
            typingTimeout = setTimeout(type, speed);
          } else {
            element.classList.remove("typing");
          }
        }

        type();
      }

      function stopTyping() {
        clearTimeout(typingTimeout);
        isTyping = false;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            startTyping();
          } else {
            stopTyping();
          }
        });
      }, { threshold: threshold });

      observer.observe(element);

    });
  }